import {
  Text,
  Flex,
  Input,
  Select,
  FormLabel,
  FormControl,
} from "@chakra-ui/react";
import States from "./states";

export default function DetailsForm({
  errors,
  address,
  isBilling,
  inputChange,
}) {
  const {
    city,
    email,
    state,
    phone,
    country,
    postcode,
    lastName,
    firstName,
    address1,
    address2,
  } = address;

  return (
    <>
      <Flex
        pt="5"
        justifyContent="space-between"
        flexDirection={{ base: "column", lg: "row" }}
      >
        <Flex flexDirection="column" width={{ base: "100%", lg: "48%" }}>
          <FormControl id="firstName" isRequired>
            <FormLabel>First name</FormLabel>
            <Input
              size="md"
              isRequired
              name="firstName"
              value={firstName}
              variant="outline"
              onChange={inputChange}
              focusBorderColor="maroon"
            />
            <Text fontSize="13px" fontWeight="600" color="red">
              {errors && errors.firstName}
            </Text>
          </FormControl>
        </Flex>
        <Flex
          flexDirection="column"
          pt={{ base: "5", lg: "0" }}
          width={{ base: "100%", lg: "48%" }}
        >
          <FormControl id="lastName" isRequired>
            <FormLabel>Last name</FormLabel>
            <Input
              size="md"
              isRequired
              name="lastName"
              value={lastName}
              variant="outline"
              onChange={inputChange}
              focusBorderColor="maroon"
            />
            <Text fontSize="13px" fontWeight="600" color="red">
              {errors && errors.lastName}
            </Text>
          </FormControl>
        </Flex>
      </Flex>

      <FormControl mt="5" id="country" isRequired>
        <FormLabel>Country</FormLabel>
        <Select
          isRequired
          name="country"
          value={country}
          onChange={inputChange}
          focusBorderColor="maroon"
          placeholder="Select country"
        >
          <option value="IN">India</option>
        </Select>
        <Text fontSize="13px" fontWeight="600" color="red">
          {errors && errors.country}
        </Text>
      </FormControl>

      <FormControl mt="5" id="address1" isRequired>
        <FormLabel>Address line 1</FormLabel>
        <Input
          size="md"
          isRequired
          variant="outline"
          name="address1"
          value={address1}
          onChange={inputChange}
          focusBorderColor="maroon"
        />
        <Text fontSize="13px" fontWeight="600" color="red">
          {errors && errors.address1}
        </Text>
      </FormControl>

      <FormControl mt="5" id="address2">
        <FormLabel>Address line 2</FormLabel>
        <Input
          size="md"
          isRequired
          variant="outline"
          name="address2"
          value={address2}
          onChange={inputChange}
          focusBorderColor="maroon"
        />
      </FormControl>

      <FormControl mt="5" id="city" isRequired>
        <FormLabel>City</FormLabel>
        <Input
          size="md"
          isRequired
          name="city"
          value={city}
          variant="outline"
          onChange={inputChange}
          focusBorderColor="maroon"
        />
        <Text fontSize="13px" fontWeight="600" color="red">
          {errors && errors.city}
        </Text>
      </FormControl>

      <FormControl mt="5" id="state" isRequired>
        <FormLabel>State</FormLabel>
        <Select
          isRequired
          name="state"
          value={state}
          onChange={inputChange}
          focusBorderColor="maroon"
          placeholder="Select state"
        >
          <States />
        </Select>
        <Text fontSize="13px" fontWeight="600" color="red">
          {errors && errors.state}
        </Text>
      </FormControl>

      <FormControl mt="5" id="postcode" isRequired>
        <FormLabel>Pincode</FormLabel>
        <Input
          size="md"
          isRequired
          name="postcode"
          value={postcode}
          variant="outline"
          onChange={inputChange}
          focusBorderColor="maroon"
        />
        <Text fontSize="13px" fontWeight="600" color="red">
          {errors && errors.postcode}
        </Text>
      </FormControl>

      {isBilling && (
        <FormControl mt="5" id="phone" isRequired>
          <FormLabel>Phone (WhatsApp Number for Receiving Tracking Notifications)</FormLabel>
          <Input
            size="md"
            isRequired
            name="phone"
            value={phone}
            variant="outline"
            onChange={inputChange}
            focusBorderColor="maroon"
          />
          <Text fontSize="13px" fontWeight="600" color="red">
            {errors && errors.phone}
          </Text>
        </FormControl>
      )}

      {isBilling && (
        <FormControl mt="5" id="email" isRequired>
          <FormLabel>Email</FormLabel>
          <Input
            size="md"
            isRequired
            name="email"
            value={email}
            variant="outline"
            onChange={inputChange}
            focusBorderColor="maroon"
          />
          <Text fontSize="13px" fontWeight="600" color="red">
            {errors && errors.email}
          </Text>
        </FormControl>
      )}
    </>
  );
}
